"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const Collapse_1 = __importDefault(require("@material-ui/core/Collapse"));
const ExpandLess_1 = __importDefault(require("@material-ui/icons/ExpandLess"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const core_1 = require("@material-ui/core");
const ArrowForwardIos_1 = __importDefault(require("@material-ui/icons/ArrowForwardIos"));
function SwipeListItem(props) {
    const [open, setOpen] = react_1.useState(!props.navButton.MobileCollapsed);
    const theme = core_1.useTheme();
    const openURL = (url) => {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
    };
    const handleClick = () => {
        setOpen(!open);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ListItem_1.default, { button: true, onClick: () => handleClick() },
            react_1.default.createElement(ListItemText_1.default, { id: "categoryName", primary: react_1.default.createElement(react_1.default.Fragment, null, props.navButton.Name) }),
            open ? react_1.default.createElement(ExpandLess_1.default, null) : react_1.default.createElement(ExpandMore_1.default, null)),
        props.navButton.NavBarItems.map((btnItem, btnIndex) => {
            return react_1.default.createElement(Collapse_1.default, { key: btnIndex, in: open, timeout: "auto", unmountOnExit: true },
                react_1.default.createElement(List_1.default, { component: "div", disablePadding: true },
                    react_1.default.createElement(ListItem_1.default, { button: true, onClick: () => openURL(btnItem.Url), className: "nestedElement" },
                        react_1.default.createElement(ListItemText_1.default, { primary: btnItem.Name }),
                        react_1.default.createElement(ListItemIcon_1.default, { style: { minWidth: "5px" } },
                            react_1.default.createElement(ArrowForwardIos_1.default, { style: theme ? { color: theme.palette.third.main, height: "12px", width: "12px" } : null })))));
        })));
}
exports.default = SwipeListItem;
//# sourceMappingURL=SwipeListItem.js.map